import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Breadcrumbs, { BreadcrumbsItem as AkBreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { BreadcrumbClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import React, { PureComponent, createElement as _createElement } from 'react';
import BreadcrumbsContext from './BreadcrumbsContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const isEqual = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0, l = a.length; i < l; i++) {
    if (!a[i].equals(b[i])) {
      return false;
    }
  }
  return true;
};
export class BreadcrumbsContainer extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      breadcrumbItems: [],
      isExpanded: false
    });
    _defineProperty(this, "expand", () => {
      this.setState({
        isExpanded: true
      });
    });
    _defineProperty(this, "clearBreadcrumbItems", () => {
      this.setState({
        breadcrumbItems: []
      });
    });
    _defineProperty(this, "updateBreadcrumbItems", breadcrumbItems => {
      if (!isEqual(breadcrumbItems, this.state.breadcrumbItems)) {
        this.setState({
          breadcrumbItems,
          isExpanded: false
        });
      }
    });
    _defineProperty(this, "onBreadcrumbItemClick", breadcrumbItem => e => {
      this.props.fireAnalyticsEvent({
        eventType: BreadcrumbClickedEvent,
        actionSubjectId: breadcrumbItem.actionSubjectId
      });
      if (breadcrumbItem.onClick) {
        breadcrumbItem.onClick(e);
      }
    });
    _defineProperty(this, "render", () => {
      const Wrapper = this.props.wrapper || React.Fragment;
      return /*#__PURE__*/_jsxs(BreadcrumbsContext.Provider, {
        value: {
          clearBreadcrumbItems: this.clearBreadcrumbItems,
          updateBreadcrumbItems: this.updateBreadcrumbItems
        },
        children: [/*#__PURE__*/_jsxs(Wrapper, {
          children: [/*#__PURE__*/_jsx("div", {
            className: this.props.className,
            children: /*#__PURE__*/_jsx(Breadcrumbs, {
              isExpanded: this.props.isExpanded || this.state.isExpanded,
              onExpand: this.expand,
              children: this.state.breadcrumbItems.map((b, i) => /*#__PURE__*/_createElement(AkBreadcrumbsItem, _objectSpread(_objectSpread({}, b.toObject()), {}, {
                key: "".concat(i, "-").concat(b.text),
                onClick: this.onBreadcrumbItemClick(b)
              })))
            })
          }), this.props.rightContent ? this.props.rightContent : null]
        }), this.props.children]
      });
    });
  }
}
_defineProperty(BreadcrumbsContainer, "defaultProps", {
  isExpanded: false
});
export default withAnalytics(BreadcrumbsContainer);